import CarDetailsPart from '../DiagnosticScreen/CarDetailsPart/CarDetailsPart';
import SavedSparesPart from '../DiagnosticScreen/SavedSparesPart/SavedSparesPart';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectDiagnostic,
  selectIsDiagLoading,
  selectIsRepairLoading,
  selectRepair,
} from '../../redux/cars/selectors';
import BottomPart from '../BottomPart/BottomPart';
import css from './CompletedDocSection.module.css';
import { BsUiRadiosGrid, BsWrench } from 'react-icons/bs';
import { useEffect, useState } from 'react';
import {
  getDiagnostic,
  getRepair,
  getMainDiagnostic,
} from '../../redux/cars/operations';
import { clearDiag } from '../../redux/cars/slice';
import PartsForRepair from '../RepairScreen/PartsForRepair/PartsForRepair';
import AudioRecorder from '../AudioRecorder/AudioRecorder';
import Photos from '../RepairScreen/Photos/Photos';
import Modal from '../Modal/Modal';
import ModalForComments from '../ModalForComments/ModalForComments';
import { BsFillMicFill } from 'react-icons/bs';
import { BsCameraFill } from 'react-icons/bs';
import { BiSolidMessageDetail } from 'react-icons/bi';
import LoaderSvg from '../Loader/LoaderSvg';
import ModalForListOfRecordings from '../ModalForListOfRecordings/ModalForListOfRecordings';

export default function CompletedDocSection() {
  // const [page, setPage] = useState('diag');
  const [openAudio, setOpenAudio] = useState(false);
  const [openPhotos, setOpenPhotos] = useState(false);
  const [checkComment, setCheckComment] = useState(false);
  const chosenCar = localStorage.getItem('chosenCar');
  const particularCar = JSON.parse(chosenCar);
  const diagLoader = useSelector(selectIsDiagLoading);
  const repairLoader = useSelector(selectIsRepairLoading);
  // console.log('page', page);

  const dispatch = useDispatch();

  useEffect(() => {
    if (particularCar?.buffer_diagnostic?.id) {
      dispatch(getDiagnostic(particularCar?.buffer_diagnostic?.id));
    } else if (particularCar?.diagnostic?.id) {
      dispatch(getMainDiagnostic(particularCar?.diagnostic?.id));
    }
    particularCar?.repair &&
      particularCar?.repair?.finished_at &&
      dispatch(getRepair(particularCar?.repair_id));
  }, []);

  const completedDiag = useSelector(selectDiagnostic);
  // console.log('completedDiag', completedDiag);

  const completedDiagWithId = completedDiag?.parts?.map(diag => ({
    ...diag,
    id: Math.random(),
  }));
  // console.log('completedDiagWithId', completedDiagWithId);

  const repair = useSelector(selectRepair);
  // console.log('repair', repair);

  // console.log('completedDiagWithId', completedDiagWithId);
  useEffect(() => {
    dispatch(clearDiag());
  }, [dispatch]);

  const photos = completedDiag?.photos?.flatMap(photo => photo.url);
  const audios = completedDiag?.audios?.flatMap(audio => audio.url);

  const repairPhotos = repair?.photos?.flatMap(photo => photo.url);
  const repairAudios = repair?.audios?.flatMap(audio => audio.url);
  const repairComments = repair?.diagnostic_comments?.flatMap(
    comment => comment.comment
  );

  const onlyDiagnostic =
    (particularCar?.buffer_diagnostic || particularCar?.diagnostic) &&
    !particularCar?.mechanic_assignments?.is_repair;
  // console.log('onlyDiagnostic', onlyDiagnostic);

  const onlyRepair =
    !!particularCar?.repair_id &&
    !particularCar?.buffer_diagnostic &&
    !particularCar?.diagnostic &&
    particularCar?.mechanic_assignments?.is_repair;
  // console.log('onlyRepair', onlyRepair);

  const [page, setPage] = useState('');
  useEffect(() => {
    if (onlyRepair) {
      setPage('repair');
    } else {
      setPage('diag');
    }
  }, [onlyRepair]);

  const formatDate = rawDate => {
    const date = new Date(rawDate);

    // padStart додає "0", якщо число складається з однієї цифри (наприклад, 9 -> 09)
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  };

  return (
    <div className={css.wrapper}>
      <CarDetailsPart particularCar={particularCar} />
      {diagLoader || repairLoader ? (
        <LoaderSvg />
      ) : (
        <>
          {!onlyDiagnostic && !onlyRepair ? (
            <div className={css.btnBox}>
              <button
                className={`${css.buttons} ${page === 'diag' && css.buttonActive}`}
                onClick={() => setPage('diag')}
              >
                <p>Діагностика</p>
                <div className={css.indicator}>
                  <BsUiRadiosGrid />
                </div>
              </button>

              <button
                className={`${css.buttons} ${
                  page === 'repair' && css.buttonActive
                }`}
                onClick={() => setPage('repair')}
              >
                <p>Ремонт</p>
                <div className={css.indicator}>
                  <BsWrench />
                </div>
              </button>
            </div>
          ) : (
            <div className={css.buttons}>
              <p>
                {onlyDiagnostic
                  ? 'Діагностика'
                  : onlyRepair
                    ? 'Ремонт'
                    : 'Діагностика'}
              </p>
              <div className={css.indicator}>
                {particularCar?.buffer_diagnostic?.id ? (
                  <BsUiRadiosGrid />
                ) : particularCar?.repair_id ? (
                  <BsWrench />
                ) : (
                  <BsUiRadiosGrid />
                )}
              </div>
            </div>
          )}

          <div className={css.mediaDateBox}>
            {page === 'diag' && (
              <p className={css.text}>
                {completedDiag
                  ? formatDate(completedDiag?.created_at)
                  : '--.--.----'}
              </p>
            )}
            {page === 'repair' && (
              <p className={css.text}>
                {repair ? formatDate(repair?.finished_at) : '--.--.----'}
              </p>
            )}
            <div className={css.btnBoxCompleted}>
              <div
                className={`${css.circle} ${
                  ((audios && audios?.length > 0) ||
                    repairAudios?.length > 0) &&
                  css.circleFilled
                } `}
                onClick={() => {
                  if (
                    (Array.isArray(audios) && audios?.length > 0) ||
                    (Array.isArray(repairAudios) && repairAudios?.length > 0)
                  ) {
                    setOpenAudio(true);
                  }
                }}
              >
                <BsFillMicFill className={css.iconMedia} />
              </div>
              <div
                className={`${css.circle} ${
                  ((photos && photos?.length > 0) ||
                    repairPhotos?.length > 0) &&
                  css.circleFilled
                }`}
                onClick={() => {
                  if (
                    (Array.isArray(photos) && photos?.length > 0) ||
                    (Array.isArray(repairPhotos) && repairPhotos?.length > 0)
                  ) {
                    setOpenPhotos(true);
                  }
                }}
              >
                <BsCameraFill className={css.iconMedia} />
              </div>
              <div
                className={`${css.circle} ${(completedDiag?.general_comment || repairComments?.length > 0) && css.circleFilled}`}
                onClick={() => {
                  if (
                    completedDiag?.general_comment ||
                    (Array.isArray(repairComments) &&
                      repairComments?.length > 0)
                  ) {
                    setCheckComment(true);
                  }
                }}
              >
                <BiSolidMessageDetail className={css.icon} />
              </div>
            </div>
          </div>

          {openPhotos ? (
            <Photos
              photos={onlyDiagnostic ? photos : repairPhotos}
              setCheckPhotos={setOpenPhotos}
              completedDoc={true}
            />
          ) : (particularCar?.diagnostic?.id ||
              particularCar?.buffer_diagnostic?.id) &&
            particularCar?.repair_id ? (
            page === 'diag' ? (
              <SavedSparesPart
                setOpenAudio={setOpenAudio}
                setOpenPhotos={setOpenPhotos}
                nodes={completedDiag ? completedDiagWithId : []}
                completedDiag={completedDiag}
                completed={true}
                setCheckComment={setCheckComment}
                checkComment={checkComment}
                screen="completedDoc"
              />
            ) : page === 'repair' ? (
              <PartsForRepair
                completedRepair={true}
                repair={repair}
                screen="completedDoc"
              />
            ) : (
              ''
            )
          ) : particularCar?.buffer_diagnostic?.id ||
            particularCar?.diagnostic?.id ? (
            <SavedSparesPart
              setOpenAudio={setOpenAudio}
              setOpenPhotos={setOpenPhotos}
              nodes={completedDiag ? completedDiagWithId : []}
              completedDiag={completedDiag}
              completed={true}
              setCheckComment={setCheckComment}
              checkComment={checkComment}
              screen="completedDoc"
            />
          ) : particularCar?.repair_id ? (
            <PartsForRepair
              completedRepair={true}
              repair={repair}
              screen="completedDoc"
            />
          ) : (
            ''
          )}
        </>
      )}

      {/* {console.log(
        '{checkComment && onlyDiagnostic',
        checkComment && onlyDiagnostic
      )} */}

      {checkComment && onlyDiagnostic ? (
        <Modal isOpen={checkComment} onClose={() => setCheckComment(false)}>
          <ModalForComments
            onClose={() => setCheckComment(false)}
            comment={completedDiag?.general_comment}
            checkComment={checkComment}
          />
        </Modal>
      ) : (
        <Modal
          isOpen={checkComment}
          onClose={() => {
            setCheckComment(false);
          }}
        >
          <ModalForComments
            onClose={() => {
              setCheckComment(false);
            }}
            checkComment={checkComment}
            repair={true}
            commentsList={
              completedDiag?.general_comment
                ? [completedDiag?.general_comment, ...(repairComments ?? [])]
                : (repairComments ?? [])
            }
          />
        </Modal>
      )}

      {openAudio && !onlyDiagnostic && (
        <Modal isOpen={openAudio} onClose={() => setOpenAudio(false)}>
          <ModalForListOfRecordings
            audios={repairAudios}
            onClose={() => setOpenAudio(false)}
          />
        </Modal>
      )}

      {!openPhotos &&
        (openAudio && onlyDiagnostic ? (
          <AudioRecorder
            audioURL={audios[0]}
            completedDoc={true}
            setOpenAudio={setOpenAudio}
          />
        ) : (
          <BottomPart savedPartScreen={true} button={true} />
        ))}
    </div>
  );
}
